import { z } from 'zod';

const staffRoleSchema = z.enum([
  "doctor", "nurse", "pharmacist", "lab_tech",
  "reception", "billing", "cleaner", "security", "admin", "other"
]);

export const accountStatusSchema = z.enum(["active", "invited", "disabled"]);

export const accountSchema = z.object({
  id: z.string().optional(),
  staffId: z.string().min(1, "Staff member is required"),
  email: z.string().email("Invalid email address"),
  phone: z.string().optional(),
  role: staffRoleSchema,
  status: accountStatusSchema,
  lastLoginAt: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
});

export const accountFormSchema = z.object({
  staffId: z.string().min(1, "Staff member is required"),
  email: z.string().email("Invalid email address"),
  phone: z.string().optional(),
  role: staffRoleSchema,
  method: z.enum(["invite", "password"]),
});

export const bulkImportSchema = z.object({
  empCode: z.string().min(1, "Employee code is required"),
  email: z.string().email("Invalid email address"),
  role: staffRoleSchema,
  phone: z.string().optional(),
});

export type AccountFormData = z.infer<typeof accountFormSchema>;
export type BulkImportData = z.infer<typeof bulkImportSchema>;
